import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ActionButton } from '../sharedStyledComponents/Components';

const Button = styled(ActionButton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TextContainer = styled.span`
  position: absolute;
  font-size: 34px;
  padding-right: 35px;

  &:after {
    content: '>';
    display: block;
    height: 23px;
    line-height: 17px;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    right: 0px;
  }
`;

const ButtonGoActive = ({ className, title, ariaLabel, disabled, onClick, actionName }) => (
  <Button
    className={className}
    aria-label={ariaLabel || title}
    disabled={disabled}
    onClick={onClick}
    data-dd-action-name={actionName}
    data-testid={`workshop-modal-go-button-${disabled ? 'inactive' : 'active'}`}
  >
    <TextContainer>{title}</TextContainer>
  </Button>
);

ButtonGoActive.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  actionName: PropTypes.string,
};

ButtonGoActive.defaultProps = {
  className: '',
  ariaLabel: '',
  disabled: false,
  title: 'GO',
  actionName: 'go',
};

export default ButtonGoActive;
